<template>
  <v-row>
    <v-col cols="12">
      <span class="d-block body-2">{{line.description}}</span>
      <span class="d-block mt-2" v-if="!line.plan.tiers.length">
        <span class="mr-1 body-2 text--secondary">{{line.plan.amount | currency(activeCurrency.id)}}</span>
        <span class="mr-1 caption text--primary">{{activeCurrency.id}} por {{line.plan.product.unit_label}} / {{line.plan.frequency | frequency}}</span>
      </span>
    </v-col>
    <template v-if="line.plan.tiers.length">
      <v-col cols="12">
        <span class="d-block body-2 text--secondary font-weight-medium">Precios</span>
      </v-col>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th style="width: 450px !important;" class="text--primary font-weight-regular text-left">Cantidad</th>
              <th class="text--primary font-weight-regular text-right">Precio por {{line.plan.product.unit_label}}</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(d, i) in line.plan.tiers">
              <tr :key="i">
                <td class="py-2 caption">
                  <span class="text--secondary font-weight-regular">De {{d.quantity_from}} <template v-if="d.quantity_to">a {{d.quantity_to}}</template><template v-else>o más</template></span>
                  <span class="ml-1 text--primary">{{line.plan.product.unit_label}}(s)</span>
                </td>
                <td class="caption text-right">
                  <span class="text--secondary font-weight-medium">{{d.amount | currency(activeCurrency.id)}}</span>
                  <span class="ml-1 text--primary">{{activeCurrency.id}}</span>
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </template>
  </v-row>
</template>
<script>
import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  name: 'p-subscription-line-detail',
  props: {
    activeCurrency: {
      type: Object,
      required: true
    },
    line: {
      type: Object,
      required: true
    }
  },
  mixins: [
    GenericViewMixin
  ]
}
</script>